import React from "react"
import style from "./SelectItem.css"

export const SelectItem = ({children, onClick, isActive}) => {
    const className = isActive
        ? `${style.option} ${style.active}`
        : style.option

    return <div className={className} onClick={onClick}>
        <Indicator/>
        <div>
            {children}
        </div>
    </div>
}

export const SelectItemAlignCenter = ({children, onClick, isActive}) => {
    const className = isActive
        ? `${style.optionCenter} ${style.active}`
        : style.optionCenter

    return <div className={className} onClick={onClick}>
        <Indicator/>
        <div>
            {children}
        </div>
    </div>
}


const Indicator = () => {
    return <div className={style.indicator}>
        <div>
            <div/>
        </div>
    </div>
}